import { type Nullable } from '@Types';
import { type ProgramApplication, ProgramApplicationStatus } from './ProgramApplication.types';

export const isPendingProgramApplication = (programApplication: Nullable<ProgramApplication>) =>
    programApplication?.status === ProgramApplicationStatus.SubmittedApplication;

export const isRejectedProgramApplication = (programApplication: Nullable<ProgramApplication>) =>
    programApplication?.status === ProgramApplicationStatus.NotSelectedForAdmission;
